import { makeAutoObservable } from "mobx";

import { throttle } from "lodash";

import { MessageSeverity } from "primereact/api";

import { ToastPosition } from "../models/types/toast-position.type";

interface IMessageDetail {
  translationKey?: string;
  translationParams?: Record<string, string | number>;
  message?: string;
}

export interface IToast {
  summary: IMessageDetail;
  detail: IMessageDetail;
  severity?: MessageSeverity;
  life?: number;
  sticky?: boolean;
  delay?: number;
  replace?: boolean;
  position?: ToastPosition;
}

export class ToastStore {
  private toastQueue: IToast[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public get toastCount(): number {
    return this.toastQueue.length;
  }

  public processNextToast(): IToast | undefined {
    return this.toastQueue.shift();
  }

  public addToast(toast: IToast) {
    this.toastQueue.push(toast);
  }

  public addThrottledToast = (toast: IToast, debounceTime: number) =>
    throttle(this.addToast.bind(this, toast), debounceTime)();
}
